<template>
  <b-modal
    id="form-iframe-modal"
    size="lg"
    no-close-on-backdrop
    no-enforce-focus
    no-close-on-esc
    hide-footer
    @shown="onShown"
    @hidden="onHidden"
  >
    <b-overlay :show="!loaded" class="text-center">
      <iframe
        v-if="formUrl"
        v-resize
        :src="formUrl"
        frameBorder="0"
        width="610"
        height="auto"
        @load="onIframeLoad"
        :style="`max-width: 100%; visibility: ${!loaded ? 'hidden' : 'initial'};`"
      ></iframe>
    </b-overlay>
  </b-modal>
</template>

<script>
  export default {
    data() {
      return {
        upid: String,
        recipient_id: Number,
        loaded: false,
      }
    },
    computed: {
      formUrl() {
        if (!this.upid || typeof this.upid != 'string') return null
        let url = '/p/i/' + this.upid
        if (window.lang == 'fr' || window.lang == 'en') url += `?${window.lang}`
        return url
      },
    },
    methods: {
      onShown() {
        this.loaded = false
        this.upid = window.formIframeModalUpid
      },
      onHidden() {
        this.upid = window.formIframeModalUpid = null
      },
      onIframeLoad() {
        this.loaded = true
      },
    },
    mounted() {
      window.formIframeModal = this
    }
  }
</script>